module.exports = __webpack_public_path__ + "img/menu_frame.b1372c9b.jpg";